/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { ITextProps, ITextStyles, Text } from '@fluentui/react/lib/Text';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import { Property } from 'csstype';
import * as React from 'react';
import { getScopedTheme } from 'src/core/themes/luisStylist';

export type LuisTextProps = ITextProps & {
    size?: string;
    color?: string;
    className?: string;
    lineHeight?: string;
    isDisabled?: boolean;
    shouldWrapText?: boolean;
    fontWeight?: Property.FontWeight;
};

const theme = getScopedTheme('LuisText');

export const LuisText = React.memo((props: LuisTextProps) => {
    const { size, color, fontWeight, lineHeight, shouldWrapText = false, isDisabled = false } = props;

    const mergedStyles = mergeStyleSets(
        classNamesFunction<ITextProps, ITextStyles>()({
            root: {
                ...(size ? { fontSize: size } : {}),
                ...(color ? { color } : { color: 'inherit' }),
                ...(lineHeight ? { lineHeight } : {}),
                ...(isDisabled ? { color: theme.disabledColor } : {}),
                ...(shouldWrapText ? { whiteSpace: 'break-spaces' } : {})
            }
        }),
        props.styles
    );

    return <Text {...props} styles={mergedStyles} style={{ fontWeight }} />;
});

LuisText.displayName = 'LuisText';
